import { Button, Icon, TextLink } from '@lego/connect-components-react';
import { useRef, useState } from 'react';
import { useTemplateDownload } from '../calculation-settings-queries';
import DownloadModal from './download-modal';

type DownloadButtonProps = {
  target: string;
  /** Renders as an inline TextLink instead of a standalone button */
  inline?: boolean;
};

const DownloadButton = ({ target, inline = false }: DownloadButtonProps) => {
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const downloadButtonRef = useRef<HTMLButtonElement | null>(null);
  const downloadLinkRef = useRef<HTMLAnchorElement | null>(null);
  const { mutateAsync: downloadTemplate, isPending: isTemplateLoading } =
    useTemplateDownload();

  const triggerRef = inline
    ? (downloadLinkRef as React.RefObject<HTMLElement | null>)
    : (downloadButtonRef as React.RefObject<HTMLElement | null>);

  const handleDownload = async (
    year: number,
    priceUnitCategoryId: string,
    priceUnitIds: string[],
  ) => {
    setShowDownloadModal(false);
    const response = await downloadTemplate({
      target,
      year,
      priceUnitCategoryId: priceUnitCategoryId
        ? Number(priceUnitCategoryId)
        : null,
      priceUnitIds: priceUnitCategoryId ? null : priceUnitIds.map(Number),
    });
    if (response.downloadUrl) {
      window.location.assign(response.downloadUrl);
    }
  };

  return (
    <>
      {inline ? (
        <TextLink
          ref={downloadLinkRef}
          href="#"
          variant="emphasis"
          size="medium"
          style={{ textDecoration: 'none' }}
          onClick={(e) => {
            e.preventDefault();
            setShowDownloadModal(true);
          }}
        >
          excel data{' '}
          <Icon
            name="arrow-down-to-line"
            size="small"
            aria-label="download"
            isChild
          />
          {isTemplateLoading && '…'}
        </TextLink>
      ) : (
        <Button
          ref={downloadButtonRef}
          appearance="outline"
          variant="primary"
          size="medium"
          loading={isTemplateLoading}
          onClick={() => setShowDownloadModal(true)}
        >
          Download (.xlsx)
        </Button>
      )}
      <DownloadModal
        isOpen={showDownloadModal}
        triggerRef={triggerRef}
        onClose={() => setShowDownloadModal(false)}
        onSubmit={handleDownload}
      />
    </>
  );
};
export default DownloadButton;
